export default __webpack_public_path__ + "static/media/car1.5bd42640.jpg";